import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import CopyToClipboardTool from "../common/CopyToClipboardTool"
import ReactJson from 'react-json-view';

const UsageEventDetails = ({ eventDetail }: any): JSX.Element => {

  const jsonStyle: any = { padding: "8px", border: "1px solid", borderRadius: "5px", width: "100%", overflow: "auto" };

  const viewType = { treeView: "switch to tree view", plain: "switch to plain view" };
  const [jsonView, setJsonView] = useState(viewType.plain);
  const [toolTipTitle, setToolTipTitle] = useState(viewType.treeView);

  const toggleJsonView = () => {
    setToolTipTitle(jsonView);
    setJsonView(jsonView === viewType.plain ? viewType.treeView : viewType.plain);
  }
  return (
    <div className="row p-1 mx-0 w-100">
      <div className="col px-1">
        {jsonView === viewType.treeView ?
          <ReactJson
            src={JSON.parse(eventDetail) || {}}
            theme="bright:inverted"
            indentWidth={2}
            collapseStringsAfterLength={20}
            displayObjectSize={false}
            style={jsonStyle}
          /> :
          <textarea className="usage-event" id="selectedEvent" value={eventDetail} readOnly />
        }
      </div>
      <div className="px-0">
        <CopyToClipboardTool data={eventDetail} />
        <div>
          <Tooltip title={toolTipTitle} placement="bottom">
            <button className="btn bg-white px-0" onClick={toggleJsonView}>{`{;}`}</button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default UsageEventDetails;